<main class="page-main">
	<app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>
	<section class="page-section" id="overview">
		<h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('overview')">
			Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<app-external-resource [componentName]="'Password Field'" [includeDescription]="true"></app-external-resource>
	</section>
	<section class="page-section" id="example">
		<h2 id="sectionTitleExample" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('example')">
			Live example <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<form class="example-container k-body" [formGroup]="form">
			<div class="page-live-header">
				<select class="page-live-example-select" (change)="changeCurrLive($event)" title="Change example">
					<option value="login">Password entry</option>
					<!-- <option value="new">New password field</option> -->
				</select>
				<app-theme-switcher></app-theme-switcher>
			</div>
			<div class="page-live-example-content">
				<div class="page-live-example" [class.page-live-show]="currLive === 'login'">
					<kendo-formfield>
						<kendo-label [for]="loginPassword" text="Password (Required)"></kendo-label>
						<kendo-textbox class="sh-custom-password" formControlName="loginPassword" #loginPassword required [maxlength]="maxLength" (keydown.enter)="$event.preventDefault()">
						  <ng-template kendoTextBoxSuffixTemplate>
							<button kendoButton [title]="iconView + ' password'" [svgIcon]="toggleIcon" 
							(click)="toggleLoginVisibility()" (keydown.enter)="toggleLoginVisibility()">
								</button>
						  </ng-template>
						</kendo-textbox>
						<kendo-formerror>Enter your password to log in.</kendo-formerror>
					</kendo-formfield>
				</div>
				<!-- <div class="page-live-example" [class.page-live-show]="currLive === 'new'">
					<kendo-formfield showHints="always">
						<kendo-label [for]="password" text="New Password"></kendo-label>
						<kendo-textbox class="sh-custom-password" formControlName="password" #password required (input)="onInput($event)">
							<ng-template kendoTextBoxSuffixTemplate>
								<button kendoButton [title]="iconView" [attr.aria-label]="iconView + 'password'"  
								[svgIcon]="toggleIcon" (click)="toggleVisibility()">
								</button>
							</ng-template>
						</kendo-textbox>
						<ng-container *ngIf="strengthValue > 0 && currLive === 'new'">
							<kendo-chunkprogressbar style="margin-top: -19px;" [progressCssClass]="progressClass" [emptyCssStyle]="emptyStyles"
							[chunkCount]="4" [value]="strengthValue"></kendo-chunkprogressbar> 
						</ng-container>
						<ng-container *ngIf="strengthValue > 0 && currLive === 'new'">
							<div style="display: flex; justify-content: space-between; margin-top: -19px;">
								<kendo-formhint>Requirements:</kendo-formhint>   
								<kendo-formhint aria-live="polite" aria-label="Password strength is">{{labelText}}</kendo-formhint>
							</div>   
							<kendo-formhint>
								<ul style="margin: 0; padding-left: 15px;">
									<li>12 or more characters</li>
									<li>1 uppercase and 1 lowercase letter</li>
									<li>1 number and 1 symbol</li>
								</ul>
							</kendo-formhint>
						</ng-container>
						<kendo-formerror *ngIf="form.controls['password']?.errors?.required && form.controls['password']?.touched">Enter your password.</kendo-formerror>
						<kendo-formerror *ngIf="form.controls['password']?.errors?.minlength && form.controls['password']?.touched">Password needs to be atleast 12 characters.</kendo-formerror>
						<kendo-formerror *ngIf="form.controls['password']?.errors?.hasUpperCase && form.controls['password']?.touched">Password must have atleast 1 uppercase letter.</kendo-formerror>
						<kendo-formerror *ngIf="form.controls['password']?.errors?.hasLowerCase && form.controls['password']?.touched">Password must have atleast 1 lowecase letter.</kendo-formerror>
						<kendo-formerror *ngIf="form.controls['password']?.errors?.hasNumeric && form.controls['password']?.touched">Password must have atleast 1 number.</kendo-formerror>
						<kendo-formerror *ngIf="form.controls['password']?.errors?.hasSpecial && form.controls['password']?.touched">Password must have atleast 1 symbol.</kendo-formerror>
					</kendo-formfield>
					
					Confirm password
					<kendo-formfield>
						<kendo-label [for]="loginPassword" text="Confirm password"></kendo-label>
						<kendo-textbox class="sh-custom-password" formControlName="loginPassword" #loginPassword required>
							<ng-template kendoTextBoxSuffixTemplate>
							<button kendoButton kendoTooltip [title]="iconView" [attr.aria-label]="iconView + 'password'"  
								[svgIcon]="toggleIcon" (click)="toggleLoginVisibility()">
								</button>
							</ng-template>
						</kendo-textbox>
						<kendo-formerror>Enter your password.</kendo-formerror>
					</kendo-formfield>
				</div> -->
				<!-- <div class="page-live-example" [class.page-live-show]="currLive === 'new'" style="padding-left: 16px; margin-top: -5%; width: inherit;">
					<button kendoButton [svgIcon]="copyIcon" (click)="copyPassword()"></button>
				</div> -->
			</div>
		</form>
	</section>
	<section class="page-section" id="dev">
		<h2 id="sectionTitleDev" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('dev')">
			Developer resources <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="dev-started">
			<h3 id="subSectionTitleDevStarted" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-started')">
				Getting started <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			Added to your project's app.module.ts file:
			<code style="margin-top: 10px">import &#123; InputsModule  &#125; from
				'&#64;progress/kendo-angular-inputs';
			</code>
		</section>
		<section class="page-sub-section" id="dev-code">
			<h3 id="subSectionTitleDevCode" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-code')">
				Code examples <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<pre prism class="dark">
				{{ passwordFieldHTML }}
			</pre>
		</section>
		<section class="page-sub-section" id="dev-api">
			<h3 id="subSectionTitleDevApi" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-api')">
				API <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/inputs/api/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo Inputs API</a>
				</li>
				<li class="page-section-list-item">
					Refer to the
					<a href="components/password-field#behaviors">behaviors section</a>
					to see supported component features.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="styles">
		<h2 id="sectionTitleStyles" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('styles')">
			Styles <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-section-list">
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (light theme)
					</summary>
					<!-- <span class="page-style-list-title">All variations</span> -->
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefault" [data]="item"></app-style-row>
					</ul>
					<!-- <span class="page-style-list-title">Error</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultError" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Warning</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultWarn" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Success</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultSuccess" [data]="item"></app-style-row>
					</ul> -->
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (dark theme)
					</summary>
					<!-- <span class="page-style-list-title">All variations</span> -->
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDark" [data]="item"></app-style-row>
					</ul>
					<!-- <span class="page-style-list-title">Error</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkError" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Warning</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkWarn" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Success</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkSuccess" [data]="item"></app-style-row>
					</ul> -->
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Typography</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTypography" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Structure</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesStructure" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
		</ul>
	</section>
	<section class="page-section" id="behaviors">
		<h2 id="sectionTitleBehaviors" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('behaviors')">
			Behaviors <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="behaviors-focus">
			<h3 id="subSectionTitleBehaviorsFocus" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-focus')">
				Focus  <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					When the focus shifts to the icon button, the text field loses focus.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-disable">
			<h3 id="subSectionTitleBehaviorsDisable" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-Disable')">
				Disable <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					When disabled, the field is shown with a darkened background and the icon buttons are at 50% opacity. 
					The field, and icon button cannot be selected, focused, or interacted with in any way.
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-show">
			<h3 id="subSectionTitleBehaviorsShow" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-show')">
				Show/hide  <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					By default, password characters are hidden and appear as dots, or the browser default for hidden passwords. The dots are replaced by plain text (see Typography under 
					<a href="components/password-field#styles">Styles</a>) when the user toggles an icon button to show the password.
				</li> 
				<li class="page-section-list-item">
					The icon button is an eye icon inside the password field to the right. It should be labeled <b>Show password</b> when the password is hidden and <b>Hide password</b> when the password is shown. 
				</li> 
				<!-- <li class="page-section-list-item">
					When a user is creating or changing their password and they need to confirm it in a second field, the show/hide behavior of each field should match. 
					For example, if the user hides their password in the confirmation field, the visibility is also hidden in the first field. 
				</li>  -->
			</ul>
		</section>
		<!-- <section class="page-sub-section" id="behaviors-forgot">
			<h3 id="subSectionTitleBehaviorsForgot" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-forgot')">
				Forgot password  <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Login password fields can have a text link near the field with the label <b>Forgot password?</b> When users select this link, it takes them to a flow where they can reset or recover their password. 
				</li>
			</ul>
		</section> -->
	</section>
	<section class="page-section" id="variations">
		<h2 id="sectionTitleVariations" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('variations')">
			Variations <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="variations-login">
			<h3 id="subSectionTitleVariationsLogin" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-login')">
				Password entry  <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					A password field where users can enter an existing password. Password entry fields are usually found on login pages that allow users to gain access.  
				</li>
			</ul>
		</section>
		<!-- <section class="page-sub-section" id="variations-new">
			<h3 id="subSectionTitleVariationsNew" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-new')">
				New password field  <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					A password field when users are creating or changing a password. 
					This variation has all the same behaviors as the login field variation, but a strength indicator bar is added. 
				</li>
				<li class="page-section-list-item">
					As a user enters their password and the complexity increases or decreases, the indicator bar changes in length and color to reflect the strength level. 
					The indicator can also decrease and revert to a weaker level. 
				</li>
				<li class="page-section-list-item">
					The 4 strength levels determined by the password’s complexity are labeled: <b>Very weak, Weak, Good, and Strong</b>.
				</li>
				<li class="page-section-list-item">
					Very weak passwords have error coloring, weak and good passwords have warning coloring, and strong passwords have success coloring.  
				</li>
				<li class="page-section-list-item">
					The strength indicator is not shown when a password field is in an empty state. It appears when the user starts typing. 
				</li>
				<li class="page-section-list-item">
					This variation also has a second field immediately after the first where users are asked to confirm their new password. The two fields must match.  
				</li>
			</ul>
		</section> -->
	</section>
	<section class="page-section" id="usage">
		<h2 id="sectionTitleUsage" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('usage')">
			Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="usage-content">
			<h3 id="subSectionTitleUsageA" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-content')">
				Content <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Label</span>
					All password fields need labels. The label should be short, no more than 1-2 words. 
					Usually, labelling the field <b>Password</b> works just fine, unless more specification is needed. 
					<!-- The label for confirming a new password should be <b>Confirm password</b>.	 -->
				</li>
				<!--
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Instructional text</span>
					Password field instructional text can be used when a user is creating a password and needs to meet requirements, 
					like a certain number of unique characters. This text shouldn’t be inside the field as placeholder text and 
					ideally not hidden as a tooltip or help text.
				</li>
				-->
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Password length</span>
					As a general rule, password fields should support passwords up to 255 characters in length. There may be cases where exceptions to this are necessary. 
					For instance, systems that have shorter or longer password length limits. In those cases, the password field length limit should correspond to any limit of the system being integrated.
					<!-- The label for confirming a new password should be <b>Confirm password</b>.	 -->
				</li>

				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Error messages</span>
						<!-- New password field error messages should be specific to what the user is missing in their entry. 
						New password field error messages should be specific to what the user is missing in their entry.
						Ideally, the requirements listed in the instructional text would dynamically change based on the users entry. 
						For example, if a user didn’t have a symbol, then the requirement about symbols would get error styling.  
						If the password does not match in the confirmation field, then the error message should indicate that.  -->
						Password entry field error messages should be written in plain language that sounds human. They can guide the user forward while still maintaining security standards.
				</li>
				<!-- <li class="page-section-list-item">
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
									width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
									<title>Icon/Status/checkmark</title>
									<g id="Icon/Status/checkmark" stroke="none" stroke-width="1" fill="none"
										fill-rule="evenodd">
										<path
											d="M20.6534688,4.16908529 C20.8789629,3.94363824 21.2445273,3.94363824 21.4700213,4.16908529 L22.8308795,5.52999044 C23.0563735,5.75548448 23.0563735,6.12109588 22.8308795,6.34654293 L8.40527544,20.772194 C8.17973441,20.997641 7.81417,20.997641 7.58872295,20.772194 L1.16912053,14.3525915 C0.94362649,14.1270505 0.94362649,13.7614861 1.16912053,13.5359921 L2.5299787,12.1751339 C2.75551972,11.9496398 3.12108413,11.9496398 3.34657817,12.1751339 L7.99699919,16.8255549 L20.6534688,4.16908529 Z"
											id="" fill="#000000" />
									</g>
								</svg>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Password need to contain a symbol.
									</li>
									<li class="comparison-body-text-list-item">
										Password does not meet requirements.
									</li>
									<li class="comparison-body-text-list-item">
										Password do not match.
									</li>
								</ul>
							</div>
						</li>
						<li class="page-section-comparison-list-item comparison-do-not">
							<div class="page-section-comparison-header">
								<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
									width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
									<title>Icon/NavObjects/close</title>
									<g id="Icon/NavObjects/close" stroke="none" stroke-width="1" fill="none"
										fill-rule="evenodd">
										<path
											d="M21.4999535,10.2499803 C22.3282291,10.2499803 22.9999499,10.9217011 22.9999499,11.7499768 L22.9999499,13.2499732 C22.9999499,14.0782488 22.3282291,14.7499696 21.4999535,14.7499696 L14.7499696,14.7499696 L14.7499696,21.4999535 C14.7499696,22.3282291 14.0782488,22.9999499 13.2499732,22.9999499 L11.7499768,22.9999499 C10.9217011,22.9999499 10.2499803,22.3282291 10.2499803,21.4999535 L10.2499803,14.7499696 L3.5,14.7499696 C2.67172081,14.7499696 2,14.0782488 2,13.2499732 L2,11.7499768 C2,10.9217011 2.67172081,10.2499803 3.5,10.2499803 L10.2499803,10.2499803 L10.2499803,3.5 C10.2499803,2.67172081 10.9217011,2 11.7499768,2 L13.2499732,2 C14.0782488,2 14.7499696,2.67172081 14.7499696,3.5 L14.7499696,10.2499803 L21.4999535,10.2499803 Z"
											id="add2" fill="#000000"
											transform="translate(12.499975, 12.499975) rotate(-315.000000) translate(-12.499975, -12.499975) " />
									</g>
								</svg>
								Not This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Error invalid entry.
									</li>
									<li class="comparison-body-text-list-item">
										Error. Invalid entry. 
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li> -->
				<!-- <li class="page-section-list-item">
					Password login field error messages should be written in plain language that sounds human. They can guide the user forward while still maintaining security standards.
				</li> -->
				<li class="page-section-list-item">
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
									width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
									<title>Icon/Status/checkmark</title>
									<g id="Icon/Status/checkmark" stroke="none" stroke-width="1" fill="none"
										fill-rule="evenodd">
										<path
											d="M20.6534688,4.16908529 C20.8789629,3.94363824 21.2445273,3.94363824 21.4700213,4.16908529 L22.8308795,5.52999044 C23.0563735,5.75548448 23.0563735,6.12109588 22.8308795,6.34654293 L8.40527544,20.772194 C8.17973441,20.997641 7.81417,20.997641 7.58872295,20.772194 L1.16912053,14.3525915 C0.94362649,14.1270505 0.94362649,13.7614861 1.16912053,13.5359921 L2.5299787,12.1751339 C2.75551972,11.9496398 3.12108413,11.9496398 3.34657817,12.1751339 L7.99699919,16.8255549 L20.6534688,4.16908529 Z"
											id="" fill="#000000" />
									</g>
								</svg>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Double-check your login information and try again.
									</li>
								</ul>
							</div>
						</li>
						<li class="page-section-comparison-list-item comparison-do-not">
							<div class="page-section-comparison-header">
								<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
									width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
									<title>Icon/NavObjects/close</title>
									<g id="Icon/NavObjects/close" stroke="none" stroke-width="1" fill="none"
										fill-rule="evenodd">
										<path
											d="M21.4999535,10.2499803 C22.3282291,10.2499803 22.9999499,10.9217011 22.9999499,11.7499768 L22.9999499,13.2499732 C22.9999499,14.0782488 22.3282291,14.7499696 21.4999535,14.7499696 L14.7499696,14.7499696 L14.7499696,21.4999535 C14.7499696,22.3282291 14.0782488,22.9999499 13.2499732,22.9999499 L11.7499768,22.9999499 C10.9217011,22.9999499 10.2499803,22.3282291 10.2499803,21.4999535 L10.2499803,14.7499696 L3.5,14.7499696 C2.67172081,14.7499696 2,14.0782488 2,13.2499732 L2,11.7499768 C2,10.9217011 2.67172081,10.2499803 3.5,10.2499803 L10.2499803,10.2499803 L10.2499803,3.5 C10.2499803,2.67172081 10.9217011,2 11.7499768,2 L13.2499732,2 C14.0782488,2 14.7499696,2.67172081 14.7499696,3.5 L14.7499696,10.2499803 L21.4999535,10.2499803 Z"
											id="add2" fill="#000000"
											transform="translate(12.499975, 12.499975) rotate(-315.000000) translate(-12.499975, -12.499975) " />
									</g>
								</svg>
								Not This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Invalid credentials. Access denied.  
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="related">
		<h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('related')">
			Related <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<span class="page-related-list-title">Referenced in this section:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="components/button">Button component</a>
			</li>
			<li class="page-related-list-item">
                <a href="guidelines/colors">Colors guidelines</a>
            </li>
			<li class="page-related-list-item">
				<a href="components/icon">Icon component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/text-field">Text field component</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/typography">Typography guidelines</a>
			</li>
		</ul>
		<!-- <span class="page-related-list-title">Components and patterns that use
			password fields:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="patterns/login">Login</a>
			</li>
		</ul> -->
	</section>
	<section class="page-section" id="history">
		<h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('history')">
			Revision history <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-history-list">
			<li class="page-history-list-item" *ngFor="
						let subItem of changelogService.getChangelogBySection(
							'Password Field Component'
						)
					">
				<span class="page-history-list-item-title">{{
					changelogService.formatDate(subItem.changeDate)
					}}</span>
				<a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
							'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
							subItem.workId
						">[{{ subItem.workId }}]</a>{{ subItem.changeName }}
			</li>
		</ul>
	</section>
</main>